import React, { useContext } from 'react';
import { TextField } from 'office-ui-fabric-react';
import { useField, useFormikContext } from 'formik';

import FilterModal from 'views/components/Video/FilterModal';

import { Props } from './VehicleInput.types';
import { useBoolean } from 'hooks/useBoolean';
import { matchProperties } from './consts';
import { filtersContext, FormValues, Vehicle } from 'api/mobile/filters';

export const VehicleInput: React.FC<Props> = ({
  name,
  singleSelection,
  ...props
}) => {
  const { values, setFieldValue } = useFormikContext<FormValues>();

  const [_, { value }, { setValue }] = useField<string[]>(name);

  const [showModal, toggleModal] = useBoolean();
  const { filters, parsedFilters } = useContext(filtersContext);

  const matchedName = matchProperties[name];

  const items = parsedFilters[matchedName];

  const onFilter = (items: Record<string, unknown>[] | null) => {
    if (name === 'vehicle' && items?.[0]) {
      const [vehicle] = items as Vehicle[];
      if (vehicle.route_id) {
        setFieldValue('route', [vehicle.route_id]);
      }
      if (vehicle.branch) {
        setFieldValue('branch', [vehicle.branch]);
      }
      if (vehicle.routeType) {
        setFieldValue('routeType', [vehicle.routeType]);
      }
    }
    if (items) {
      setValue(items.map((item) => item.key as string));
    } else {
      setValue([]);
    }
  };

  const serializedValue = value
    .map((key) => {
      const found = (items as any[]).find((item) => item.key === key);
      return found?.primaryField || '';
    })
    .join(', ');

  return (
    <>
      <TextField
        {...props}
        value={serializedValue}
        onClick={toggleModal}
        readOnly
      />
      {showModal && (
        <FilterModal
          singleSelection={singleSelection}
          title={name === 'vehicle' ? 'depotNumber' : name}
          allFilters={filters}
          onCloseModal={toggleModal}
          onFilter={onFilter}
          selectedFilters={{ ...values, depotNumber: values.vehicle }}
          items={items || []}
          viewTitle={props.label || ''}
        />
      )}
    </>
  );
};
